import React from "react";
import styled from "styled-components";
import { richTextHelper, getColours } from "@helpers";
import CTAButton from "./CTAButton";
import type { IActionCardFields } from "@types-contentful";

const Section = styled.div<{
	resetModuleMarginBottom: "No" | "Yes" | undefined;
	backgroundColour: string | undefined;
}>`
  ${({ resetModuleMarginBottom }) =>
		resetModuleMarginBottom === "Yes" && "margin-bottom: 0px !important"};
  background-color: ${(props) => getColours(props.backgroundColour)};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 40px 35px 40px 35px;
`;

const Title = styled.h2.attrs<{
	headerLevel: "H1" | "H2" | "H3" | "H4" | "H5" | undefined;
	headerAlignment: "Left" | "Center" | "Right" | undefined;
}>(({ headerLevel }) => ({
	as: headerLevel ? headerLevel.toLowerCase() : undefined,
}))<{
	headerLevel: "H1" | "H2" | "H3" | "H4" | "H5" | undefined;
	headerAlignment: "Left" | "Center" | "Right" | undefined;
}>`
  margin-bottom: 20px;
  text-align: ${({ headerAlignment }) =>
		headerAlignment ? headerAlignment.toLowerCase() : "left"};
  width: 100%; // Ensure the title takes full width for alignment to work
`;

const Description = styled.span`
  margin-bottom: 30px;
`;

const CTAContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 20px;
  width: 100%;
`;

const ActionCard = ({
	header,
	headerLevel,
	headerAlignment,
	subCopy,
	backgroundColour,
	ctaButtonColour,
	ctaUrl,
	ctaText,
	name,
	removeNegativeSpacingBelowModule,
}: IActionCardFields) => {
	return (
		<Section
			backgroundColour={backgroundColour}
			resetModuleMarginBottom={removeNegativeSpacingBelowModule}
		>
			<Title headerLevel={headerLevel} headerAlignment={headerAlignment}>
				{header}
			</Title>
			{subCopy && <Description>{richTextHelper(subCopy)}</Description>}
			{ctaText && ctaUrl && (
				<CTAContainer>
					{ctaText.map((cta, index) => (
						<CTAButton
							key={cta}
							url={ctaUrl[index] || ""}
							ctaButtonColour={ctaButtonColour}
							gtmCtaPosition={name}
							gtmCtaText={cta}
						>
							{cta}
						</CTAButton>
					))}
				</CTAContainer>
			)}
		</Section>
	);
};

export default ActionCard;
